module.exports = __webpack_public_path__ + "img/home-2.4fd799dc.png";